const ContractorTypes = Object.freeze({
  BUSINESS: 1,
  INDIVIDUAL: 2,
});

export default ContractorTypes;
